import { twMerge } from 'tailwind-merge';
import Tooltip, { type TooltipProps } from '@/components/Tooltip';
import { InfoIcon } from '@/icons';
import { classes } from './utils';

export interface InfoPointProps extends Omit<
  TooltipProps,
  'children' | 'title'
> {
  iconClassName?: string;
  content: string;
}

export default function InfoPoint({
  arrow = true,
  iconClassName,
  content,
  ...props
}: InfoPointProps) {
  return (
    <Tooltip arrow={arrow} title={content} {...props}>
      <InfoIcon className={twMerge(classes.icon, iconClassName)} />
    </Tooltip>
  );
}
